import styled from "styled-components";

export const ContainerAction = styled.div`
  display: flex;
  flex-direction: row;
`;
export const ContainerHandleTask = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
